import { useStore } from '../FronteggStoreContext';
import { useSnapshot } from '../useSnapshot';
export function useTenantsState() {
  const state = useStore().store.auth.tenantsState;
  return useSnapshot(state);
}
export const useTenantsActions = () => {
  return useStore().stateActions.auth.tenantsActions;
};